import { createAction, props } from '@ngrx/store';

/** Adds an action prefix to the start of the action name */
const prefixer = (action: string) => `[SignedInUser] ${action}`;

const login = createAction(prefixer('login'), props<{ user: any }>());
const logout = createAction(prefixer('logout'));

export const signedInUserActions = { logout, login };